import { OutliersDataItem } from 'widgets/outliers/data/outliersData';
import { seriesSvgMulti } from '@d3fc/d3fc-series';
import { autoYGridlines } from 'utils/components/TimeSeriesChart/gridlines';
import { annotationSvgGridline } from '@d3fc/d3fc-annotation';
import { buildBubblesSeries } from './bubblesSeries';
import { BubbleMouseOver } from 'widgets/outliers/components/chart/BubbleMouseOver';
import { Dimensions } from 'utils/types/Dimensions';

export interface OutliersChartSeries {
    bubbleMaxPx: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    series: any;
}

export function outliersChartSeries(
    flipAxis: boolean | undefined,
    plotAreaDimensions: Dimensions,
    dataItems: OutliersDataItem[],
    bubbleMouseOver: BubbleMouseOver,
    selectedOrderIds: string[]
): OutliersChartSeries {
    const { series: bubblesSeries, bubbleMaxPx } = buildBubblesSeries(
        flipAxis,
        plotAreaDimensions,
        dataItems,
        bubbleMouseOver,
        selectedOrderIds
    );
    return {
        bubbleMaxPx,
        series: seriesSvgMulti().series([
            autoYGridlines(true),
            annotationSvgGridline().xTickValues([0]).yTickValues([]),
            bubblesSeries,
        ]),
    };
}
